import styled from 'styled-components';
import { Container } from '@material-ui/core';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const SSubscriptionStepContainer = styled(Container)`
  height: 100%;

  padding-bottom: 48px;

  .step-breadcrumbs {
    margin-bottom: 8px;
  }

  .step-title {
    margin-bottom: 16px;

    span {
      margin-left: 6px;
      opacity: 0.4;
    }
  }

  .step-desc,
  .error-wrapper,
  .alert-wrapper {
    margin-bottom: 24px;
  }

  .step-btn {
    min-width: 200px;
  }

  ${breakpoints.up('md')} {
    .step-breadcrumbs {
      margin-bottom: 30px;
    }

    .step-title {
      margin-bottom: 16px;
    }

    .step-desc,
    .error-wrapper {
      margin-bottom: 20px;
    }
  }

  ${breakpoints.up('sm')} {
    .submit-error-alert {
      max-width: 475px;
    }
  }

  .promocode {
    margin-bottom: 30px;
  }
`;

export default SSubscriptionStepContainer;
